import { Stack, Typography } from '@mui/material';

export default function ModuleChip({ title }) {
	return (
		<Stack
			direction="row"
			alignItems="center"
			spacing={1}
			sx={{
				backgroundColor: '#EDEDFC',
				borderRadius: '4px',
				padding: '2px 8px',
				width: 'fit-content',
			}}
		>
			<Typography
				sx={{
					fontSize: '14px',
					color: '#151357',
					fontWeight: 500,
					fontFamily: 'Roboto, sans-serif',
				}}
			>
				{title}
			</Typography>
		</Stack>
	);
}
